import React from 'react'
import { constants } from 'common/helpers'

import appStoreImage from './images/appStore.svg'


const handleClick = () => {
  if (window._snowplow) {
    window._snowplow.track(constants.snowplowEvents.appStore.badgeClick, {
      page: window.location.pathname,
    })
  }
}

const AppStoreButton = ({ isLandings }) => (
  <a
    href={`https://app.adjust.com/kze335m?campaign=${isLandings ? 'bottom-badge-landing' : 'bottom-badge-site'}`}
    rel="noopener noreferrer"
    target="_blank"
    // for landings
    data-s-onclick-track-mixpanel={constants.snowplowEvents.appStore.badgeClick}
    data-s-onclick-track-mixpanel-with-pathname
    data-s-onclick-track-mixpanel-with-snowplow
    // for site
    onClick={handleClick}
  >
    <img src={appStoreImage} alt="App store" />
  </a>
)


export default AppStoreButton
